import DeviceNumber from './DeviceNumber'

export default DeviceNumber
